import { render, staticRenderFns } from "./CreateAndUpdate.vue?vue&type=template&id=8b5310f0"
import script from "./CreateAndUpdate.vue?vue&type=script&lang=js"
export * from "./CreateAndUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateAndUpdate.vue?vue&type=style&index=0&id=8b5310f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports